import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from "reactstrap";
import { map } from "lodash";
import i18n from "../../../i18n";
import { delCostCenterDelete } from "../../../helpers/api_rombo_helper";

const DeleteCostCenterModal = ({ isOpen, toggle, setShowAlertSuccess, setDeleteCostCenterModal, setCheckCostCenter, checkCostCenter, reloadCostCenter, setReloadCostCenter, setTextHeader, setTextBody, token }) => {

  const deleteCostCenter = () => {
    map(checkCostCenter, (costCenter, key) => {
      delCostCenterDelete(token, costCenter.id)
      document.getElementById(costCenter.id).checked = false
      setReloadCostCenter(!reloadCostCenter)
    })
    setCheckCostCenter([])
    setShowAlertSuccess(true)
    setDeleteCostCenterModal(false)
    setTextHeader(i18n.t("DestroyCostCenter"))
    setTextBody(i18n.t("SuccessDeleteCostCenter", { name: checkCostCenter[0].name }))
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"lg"}
    >
      <div>
        <p className="cancellation-title">{i18n.t("RemoveCostCenter")}</p>
        <p className="cancellation-confirmation">{i18n.t("Confirmation")}</p>
        <div className="separator"></div>
        <ModalBody className="mt-0 pt-0">
          <Row>
            <Col>
              <p/>
              <p className="cancellation-text">
                {i18n.t("TextDelete1")} {i18n.t("TextDelete2")} {i18n.t("TextDelete3")}
              </p>
              {map(checkCostCenter, (costCenter, key) => (
                <p className="cancellation-text" key={key}> - {costCenter.name}</p>
              ))}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-danger"
            type="button"
            onClick={deleteCostCenter}
          >
            {i18n.t("Accept")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            data-dismiss="modal"
            onClick={toggle}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

DeleteCostCenterModal.propTypes = {
  setShowAlertSuccess: PropTypes.func,
  setDeleteCostCenterModal: PropTypes.func,
  toggle: PropTypes.func,
  setReloadCostCenter: PropTypes.func,
  isOpen: PropTypes.bool,
  token: PropTypes.object,
  setTextHeader: PropTypes.func,
  setTextBody: PropTypes.func
}

export default DeleteCostCenterModal;
